import type { Permission } from '@idc-forms/permissions'
import { Navigate, Outlet } from 'react-router'
import useAuth from '@/features/auth/hooks/use-auth'
import type { TypeAccount } from '@/features/users/models/user'
import { usePermissions } from '@/shared/hooks/use-permissions'

type ProtectedRouteProps = {
  permission?: Permission | Permission[]
  allowedAccounts?: TypeAccount[]
  redirectTo?: string
}

export function ProtectedRoute({ permission, allowedAccounts, redirectTo }: ProtectedRouteProps) {
  const isBoneyardBuild = typeof window !== 'undefined' && window.__BONEYARD_BUILD === true
  const { has, hasAny } = usePermissions()
  const { auth } = useAuth()

  if (isBoneyardBuild) return <Outlet />
  if (!permission && (!allowedAccounts || allowedAccounts.length === 0)) return <Outlet />

  let allowed = false

  if (permission) {
    allowed = Array.isArray(permission) ? hasAny(permission) : has(permission)
  }

  if (!allowed && allowedAccounts && allowedAccounts.length > 0 && auth?.typeAccount) {
    allowed = allowedAccounts.includes(auth.typeAccount)
  }

  if (!allowed) {
    return redirectTo ? <Navigate to={redirectTo} replace /> : null
  }

  return <Outlet />
}
